import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import { BindOrgRequest } from "../../generated/core-api";

interface BindUserGroupToOrgParams {
  groupId: string;
  request: BindOrgRequest;
}

export function useBindUserGroupToOrg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupId, request }: BindUserGroupToOrgParams) =>
      api.bindUserGroupToOrg(groupId, request),
    onSuccess: (_data, { groupId }) => {
      queryClient.invalidateQueries({
        queryKey: ["user-groups", groupId, "org-bindings"],
      });
    },
  });
}
